/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FieldPasswordSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FieldPasswordSmall',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 11 * scale,
      viewBox: '0 0 16 11',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"clipPath":"url(#wf-svg-FieldPasswordSmall-__a)"},createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","fill":"currentColor","d":"M12 4a4 4 0 0 1-5.562 3.684L4.923 9.197l-.686-.685-.707.707.686.685-.707.707-.686-.685-.707.707.686.685-.68.681H0V9.88l4.317-4.317A4 4 0 1 1 12 4m-1.5-1a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"})),createElement('defs', null,createElement('clipPath', {"id":"wf-svg-FieldPasswordSmall-__a"},createElement('path', {"fill":"none","d":"M0 0h12v12H0z"}))))
}
